import { render, staticRenderFns } from "./JobCharges.vue?vue&type=template&id=56e5ef6a&scoped=true&"
import script from "./JobCharges.vue?vue&type=script&lang=js&"
export * from "./JobCharges.vue?vue&type=script&lang=js&"
import style0 from "./JobCharges.vue?vue&type=style&index=0&id=56e5ef6a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56e5ef6a",
  null
  
)

export default component.exports